import i18next from 'i18next';
import { Link } from 'react-router-dom';

import { buttonVariants } from '@/components/ui/button';

const MissionReports = () => {
  return (
    <div className="flex items-center justify-center h-full">
      <Link to="/mission-reports/new" className={buttonVariants({ variant: 'secondary' })}>
        {i18next.t('mission_reports.add_new_report')}
      </Link>
    </div>
  );
};

export default MissionReports;
